var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckGreenSquare(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 37.9163H14.9999C5.94992 37.9163 2.08325 34.0497 2.08325 24.9997V14.9997C2.08325 5.94967 5.94992 2.08301 14.9999 2.08301H24.9999C34.0499 2.08301 37.9166 5.94967 37.9166 14.9997V24.9997C37.9166 34.0497 34.0499 37.9163 24.9999 37.9163ZM14.9999 4.58301C7.31659 4.58301 4.58325 7.31634 4.58325 14.9997V24.9997C4.58325 32.683 7.31659 35.4163 14.9999 35.4163H24.9999C32.6833 35.4163 35.4166 32.683 35.4166 24.9997V14.9997C35.4166 7.31634 32.6833 4.58301 24.9999 4.58301H14.9999Z",
    fill: "#2EB62C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7316 15.6436C29.2198 15.1555 29.2198 14.364 28.7316 13.8759C28.2435 13.3877 27.452 13.3877 26.9638 13.8759L17.3674 23.4724L12.9002 19.0052C12.4121 18.5171 11.6206 18.5171 11.1325 19.0052C10.6443 19.4934 10.6443 20.2849 11.1325 20.773L16.4835 26.124C16.9716 26.6122 17.7631 26.6122 18.2512 26.124L28.7316 15.6436Z",
    fill: "#2EB62C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenSquare);
export default __webpack_public_path__ + "static/media/check-green-square.bbcd65c8ed94a98ae1f4809fc236a5c0.svg";
export { ForwardRef as ReactComponent };